import { render } from "./TheBanner.vue?vue&type=template&id=9caa4b7e"
import script from "./TheBanner.vue?vue&type=script&lang=js"
export * from "./TheBanner.vue?vue&type=script&lang=js"

import "./TheBanner.vue?vue&type=style&index=0&id=9caa4b7e&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__